var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#616160;}\r\n\t.st1{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.612,1.023H5.838c-0.752,0-1.363,0.611-1.363,1.363v2.03H2.446c-0.752,0-1.363,0.611-1.363,1.363v7.774 c0,0.751,0.611,1.362,1.363,1.362h7.774c0.752,0,1.363-0.611,1.363-1.362v-2.03h2.029c0.752,0,1.363-0.611,1.363-1.363V2.386 C14.976,1.635,14.364,1.023,13.612,1.023z M10.583,13.554c0,0.2-0.163,0.362-0.363,0.362H2.446c-0.2,0-0.363-0.162-0.363-0.362 V5.779c0-0.2,0.163-0.363,0.363-0.363h2.029v4.744c0,0.752,0.611,1.363,1.363,1.363h4.745V13.554z M13.976,10.16 c0,0.2-0.163,0.363-0.363,0.363H5.838c-0.2,0-0.363-0.163-0.363-0.363V2.386c0-0.2,0.163-0.363,0.363-0.363h7.774 c0.2,0,0.363,0.163,0.363,0.363V10.16z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 16,
    height: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.7172d6ebcba1a397e202186d8474ae6d.svg";
export { ForwardRef as ReactComponent };